import { FETCH_NOTES, FETCH_NOTES_SUCCESS, FETCH_NOTES_FAILURE, SAVE_NOTES_SUCCESS,
  SAVE_NOTES_FAILURE, DELETE_NOTES_SUCCESS, DELETE_NOTES_FAILURE, NOTES_AJAX_CALL,
  NOTES_CLEAR_AJAX_CALL } from '../actions/Notes'

const initialState = {
  list: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null
}

export default function notes (state = initialState, action) {
  switch (action.type) {
    case FETCH_NOTES:
      return {...state, loading: true, error: null, list: null}
    case FETCH_NOTES_SUCCESS:
      return {...state, list: action.payload, loading: false, error: null}
    case FETCH_NOTES_FAILURE:
      return {...state, error: action.payload, loading: false, list: null}
    case SAVE_NOTES_SUCCESS:
      return {...state,
        list: ((state.list.findIndex(x => x.id === action.payload.id) === -1)
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
            return (item.id === action.payload.id) ? action.payload : item
          })),
        ajaxStatus: null,
        ajaxSpinner: false}
    case SAVE_NOTES_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case DELETE_NOTES_SUCCESS:
      return {...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload
        }),
        ajaxStatus: null,
        ajaxSpinner: false}
    case DELETE_NOTES_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case NOTES_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case NOTES_CLEAR_AJAX_CALL:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notes.js